export const SET_SID = '@@common/SET_SID';
export const SET_LANG = '@@common/SET_LANG';
export const SAVE_PHONE = '@@common/SAVE_PHONE';
export const SAVE_MEMBER_ID = '@@common/save_member_id';
export const LOGOUT = '@@common/logout';